import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/aiAvatar/initialState'
import reducers from 'store/features/aiAvatar/reducers'

const aiAvatarSlice = createSlice({
  name: 'aiAvatar',
  initialState: getInitialState(),
  reducers
})

export default aiAvatarSlice
